
import { computed, defineComponent, ref, getCurrentInstance } from "vue-demi";

import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";

// import { APPROVED_SERVICE_STATUS, TO_REVIEW_SERVICE_STATUS } from "@/constants/services"; TODO

export default defineComponent({
  name: "DocumentsTreeExpertActions",
  components: {
    ActionButtonsV2: () => import("@/components/ActionContainer/ActionButtonsV2.vue"),
    CreateTaskPopUp: () => import("@/components/Popups/CreateTaskPopUp.vue"),
  },

  props: {
    directoryId: {
      type: Number,
      default: 0,
    },
    directoryName: {
      type: String,
      default: "",
    },
    isApproved: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update"],

  setup(props, { emit }) {
    const instance = getCurrentInstance()?.proxy;

    const route = getCurrentInstance()?.proxy?.$route;

    const caseId = computed(() => Number(route.params.id ?? 0));

    const loading = ref(false);

    const documentIsApproved = computed(() => {
      return props.isApproved;
    });

    const isApproveButtonDisabled = computed(() => {
      return props.directoryName === "Additional documents";
    });

    const textButton = computed(() => {
      const label = documentIsApproved.value
        ? instance?.$tc("labels.withdraw")
        : instance?.$tc("labels.approve");

      return `${label}`;
    });

    async function updateDocStatus() {
      if (!props.directoryId) return console.log("no directory id");

      const decision = documentIsApproved.value ? "withdraw" : "approve";

      try {
        const { data } = await axios.get(
          API_ROUTES.DOCUMENTS_DIRECTORY_DECISION(props.directoryId, decision)
        );

        if (!data) return;

        emit("update", { data, approved: !documentIsApproved.value });
      } catch (error) {
        console.error(`Error documents decision:`, error);
      }
    }

    const createTaskPopup = ref(false);

    function openCreateTaskPopUp() {
      createTaskPopup.value = true;
    }

    function closeCreateTaskPopUp() {
      createTaskPopup.value = false;
    }

    return {
      caseId,
      textButton,
      isApproveButtonDisabled,
      updateDocStatus,
      documentIsApproved,
      loading,
      createTaskPopup,
      openCreateTaskPopUp,
      closeCreateTaskPopUp,
    };
  },
});
